import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import ChartFrame, { CHART_PALETTE, TOOLTIP_STYLE } from './ChartFrame';
import { PMS_LABELS, fmtNumber } from '../derive';

export default function CanvasProperties({ rows = [], total = 0, onSelectPms }) {
  const data = rows.map((row) => ({
    id: row.id || row._id,
    label: PMS_LABELS[row.id || row._id] || row.label || row.id || row._id,
    count: row.count || 0,
  }));
  const chartTotal = data.reduce((s, d) => s + d.count, 0);

  return (
    <ChartFrame
      title="Properties by PMS"
      subtitle={`${fmtNumber(total || chartTotal)} properties · click a bar for details`}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 8, bottom: 0, left: -16 }}>
          <CartesianGrid stroke="#f4f4f5" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 10, fill: '#71717a' }} />
          <YAxis tick={{ fontSize: 10, fill: '#71717a' }} allowDecimals={false} />
          <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: 'rgba(99,102,241,0.06)' }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]} isAnimationActive={false}>
            {data.map((d, i) => (
              <Cell
                key={d.id}
                fill={CHART_PALETTE[i % CHART_PALETTE.length]}
                cursor="pointer"
                onClick={() => onSelectPms?.(d.id)}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartFrame>
  );
}
